/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Confirmation from './Confirmation/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/Edit/Content/ResetAction/Content",
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let imageIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'image',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="medium"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Confirmation/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Confirmation/Content'))}
 marginLeft={dtSpaceXs}
 data="image"
 disabled={imageIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Reset"
/>
)}
</TysiaButton>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
{children}
</React.Fragment>)
}